<template>
  <div class="public-smartad" :class="mainClass" :style="mainStyle">
    <template v-if="isText">
      <div class="public-smartad-content public-smartad-content-text">
        <a
          :href="smartad.url"
          target="blank"
          class="border-hover"
          @click="onTextLinkClick"
        >
          <span>
            {{ smartad.text }}
          </span>
        </a>
      </div>
    </template>

    <template v-if="isVideo">
      <div class="public-smartad-content public-smartad-content-video" :class="smartAdContentVideoClass" @click="onVideoClick">
        <div class="public-smartad-content-video-container">
          <YoutubeVideo
            v-if="isVideoYoutube"
            width="100%"
            height="100%"
            :src="videoUrl"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope;"
            allowfullscreen
            class="videoFrame"
          ></YoutubeVideo>
          <VimeoVideo
            v-if="!isVideoYoutube"
            width="100%"
            height="100%"
            :src="videoUrl"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope;"
            allowfullscreen
            class="videoFrame"
          ></VimeoVideo>
          <div class="public-smartad-content-video-clicker" v-if="showVideoClicker" @click="onVideoClick"></div>
        </div>
        <!-- <iframe
          width="100%"
          height="100%"
          :src="videoUrl"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope;"
          allowfullscreen
        ></iframe> -->
      </div>
    </template>

    <template v-if="isImage">
      <div class="public-smartad-content public-smartad-content-image">
        <span v-if="!smartad.filePath">{{$t('smartAd.errors.noImage')}}</span>
        <a
          v-if="smartad.filePath"
          :href="smartad.url"
          target="blank"
          @click="onPictureLinkClick"
        >
          <img :src="$processUrl(smartad.filePath)" />
        </a>
      </div>
    </template>

    <template v-if="isDocument">
      <div class="public-smartad-content public-smartad-content-document">
        <!-- <a
          :href="$processUrl(smartad.filePath)"
          target="blank"
          class="border-hover"
          @click="onDocumentLinkClick"
        > -->
          <!-- <img src="@/assets/img/sa-brochure.jpg" /> -->
          <PrimaryButton @click="onDocumentLinkClick">
            <span>{{ smartad.text }}</span>
          </PrimaryButton>
        <!-- </a> -->
      </div>
    </template>
  </div>
</template>

<i18n>
{
    "en": {
        "smartAd": {
            "errors": {
                "noImage": "No image."
            }
        }
    },
    "es": {
        "smartAd": {
            "errors": {
                "noImage": "No hay imagen."
            }
        }
    },
    "fr": {
        "smartAd": {
            "errors": {
                "noImage": "Aucune image."
            }
        }
    },
    "pt": {
        "smartAd": {
            "errors": {
                "noImage": "Nenhuma imagem."
            }
        }
    },
    "de": {
        "smartAd": {
            "errors": {
                "noImage": "Kein Bild."
            }
        }
    },
    "nl": {
        "smartAd": {
            "errors": {
                "noImage": "Geen beeld."
            }
        }
    }
}
</i18n>

<script>
import Vue from 'vue'
import Icon from '@/components/commons/icon/Icon.vue'
import PrimaryButton from '@/components/v3/buttons/PrimaryButton.vue'
import YoutubeVideo from '@/components/commons/videos/YoutubeVideo.vue'
import VimeoVideo from '@/components/commons/videos/VimeoVideo.vue'

export default {
  components: {
    Icon,
    PrimaryButton,
    YoutubeVideo,
    VimeoVideo
  },
  props: {
    smartad: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      isVideoExpanded: false,
      windowWidth: window.innerWidth,
      gaPageName: '/user-document',
      globalScale: 1,
      resizeObserver: null
    }
  },
  mounted () {
    this.resizeObserver = new ResizeObserver(entries => {
        entries.forEach(entry => {
            // console.log('resizeObserver', entry.contentRect.width, entry);
            this.checkDocumentSize(entry.contentRect.width)
        });

    });
    this.resizeObserver.observe(this.$el.parentElement)
    // window.addEventListener('resize', () => {
    //   this.checkDocumentSize()
    // })
    // Vue.nextTick(this.checkDocumentSize)
    // this.checkDocumentSize()
  },
  computed: {
    isText() {
      return this.smartad.type === 1
    },
    isVideo() {
      return this.smartad.type === 2
    },
    isImage() {
      return this.smartad.type === 3
    },
    isDocument() {
      return this.smartad.type === 4
    },
    isActive() {
      return this.smartad.isActive
    },
    mainClass() {
        return {
            'is-image': this.isImage,
            'public-smartad-active': this.isActive
        }
    },
    mainStyle() {
        return {
            width: Math.floor(this.globalScale * 620) + 'px',
            height: Math.floor(this.globalScale * 270) + 'px'
        }
    },
    videoUrl () {
      return this.smartad.url || ''
    },
    isVideoYoutube () {
      return this.videoUrl.indexOf('youtube') >= 0 || this.videoUrl.indexOf('youtu.be') >= 0
    },
    isMobileVersion () {
      return this.windowWidth <= 768
    },
    smartAdContentVideoClass () {
      return this.isVideoExpanded ? 'video-expanded' : ''
    },
    showVideoClicker () {
      return this.isMobileVersion && !this.isVideoExpanded
    }
  },
  methods: {
    checkDocumentSize(w) {
        this.windowWidth = window.innerWidth
        if (!w) {
            w = this.$el.parentElement.getBoundingClientRect().width
        }
        // console.log('checkDocumentSize', this.smartad.type, w)
        const availableWidth = Math.floor((w - 10) / 2)
        this.globalScale = availableWidth / 620
    },
    onVideoClick(e) {
      this.onSmartAdClick()
      this.$ga.event(this.gaPageName, 'video-click', '', 0)
      e.preventDefault()
      e.stopImmediatePropagation()
      e.stopPropagation()
      if (this.isMobileVersion || this.isVideoExpanded) {
        this.isVideoExpanded = !this.isVideoExpanded
      }
    },
    onTextLinkClick () {
      this.onSmartAdClick()
      this.$ga.event(this.gaPageName, 'text-link-click', '', 0)
    },
    onPictureLinkClick () {
      this.onSmartAdClick()
      this.$ga.event(this.gaPageName, 'picture-link-click', '', 0)
    },
    onDocumentLinkClick () {
      window.open(this.$processUrl(this.smartad.filePath), '_blank')
      this.onSmartAdClick()
      this.$ga.event(this.gaPageName, 'document-link-click', '', 0)
    },
    onSmartAdClick () {
      this.$emit('click', this.smartad)
    }
  }
}
</script>

<style lang="stylus">
@import "~assets/v3/css/variables.styl";

$sa-bg = linear-gradient(-12deg, #f0efed, #f4)
$sa-bg = linear-gradient(-12deg, lighten(#f0efed, 4), lighten(#f4, 4))

$inside-width = 1260px
$outside-padding = 84px
$outside-width = $inside-width + ($outside-padding * 2)

$smartad-width = 620px
$smartad-height = 270px
$smartad-text-border = 12px

$colors-blue-3 = #3F69FF
$colors-blue-1 = #97d2f0

.public-smartad
    width $smartad-width
    height $smartad-height
    background-color #FBFBFB
    // box-shadow 0px 2px 2px rgba(163, 163, 164, 0.25)
    position relative
    overflow hidden
    visibility hidden
    border-radius 5px

    &.public-smartad-active
        visibility visible

    .public-smartad-content
        width 100%
        height 100%
        color #626262
        display flex
        justify-content center
        align-items center
        box-sizing border-box
        text-align center
        font-weight 0
        font-size 16px
        responsive-styling(font-size, 6, 16, $outside-width * 0.1, $outside-width)

        a
            box-sizing border-box
            width 100%
            height 100%
            padding 36px
            responsive-styling-auto-scale(padding, 36, $outside-width)
            color $colors-blue-3
            transition color 0.35s, opacity 0.35s, outline-offset 0.55s cubic-bezier(.41,2.24,.61,1)
            display flex
            justify-content center
            flex-flow column
            align-items center
            color $colors-blue-3
            font-weight bold

            &:hover
                color lighten($colors-blue-3, 10)

        &-text
            flex-flow row
            background $sa-bg
            font-weight bold

            a
                color white
                width $smartad-width - $smartad-text-border
                height $smartad-height - $smartad-text-border
                background-color $colors-blue-3 !important

                &:hover
                    color white
                    opacity 0.8

        &-document
            flex-flow column
            // background $sa-bg
            background-image url('~@/assets/img/sa-brochure.jpg')
            background-size 100% 100%

            .primary-button
                position absolute
                responsive-styling-auto-scale(bottom, 40, $outside-width)
                responsive-styling-auto-scale(font-size, 16, $outside-width)
                responsive-styling-auto-scale(padding-top, 5, $outside-width)
                responsive-styling-auto-scale(padding-bottom, 5, $outside-width)
                responsive-styling-auto-scale(padding-left, 8, $outside-width)
                responsive-styling-auto-scale(padding-right, 8, $outside-width)
                responsive-styling-auto-scale(min-height, 36, $outside-width)

        &-video
            width 100%
            height 100%
            background-color black
            position relative

            .public-smartad-content-video-container
                top 50%
                left 50%
                width 100%
                height 100%
                transform translate(-50%, -50%)
                position absolute

            &.video-expanded
                position fixed
                top 0
                left 0
                z-index 10000
                background-color rgba(0, 0, 0, 0.8)

                .public-smartad-content-video-container
                    height calc((100vw - 40px) * 0.56)
                    max-height calc(100% - 40px)
                    position absolute
                    width 100%
                    max-width calc(100% - 40px)

                    .videoFrame
                        top 0
                        left 0
                        position absolute

                    @media (min-aspect-ratio: 1000000/1000001)
                        width calc((100vw - 40px) * 0.74)

            .public-smartad-content-video-clicker
                position absolute
                top 0
                left 0
                width 100%
                height 100%
                background-color rgba(0, 0, 0, 0.0)

        &-image
            width 100%
            height 100%

            a
                padding 0 !important

            img
                width 100%
                height 100%
                object-fit contain

    &.is-image
        background-color white

  @keyframes document-download-anim
    0%
      transform translateY(0px)
    50%
      transform translateY(6px)
    100%
      transform translateY(0px)
</style>



// WEBPACK FOOTER //
// src/modules/documents/components/PublicDocumentSmartAd.vue